import { render, staticRenderFns } from "./PerPager.vue?vue&type=template&id=31a7c2f3&"
import script from "./PerPager.vue?vue&type=script&lang=js&"
export * from "./PerPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports